'use client'

import React, { useState, useEffect } from 'react';
import { P2, Wrapper, RecklessFont, ChromaticFont, Container } from '@components/styled';
import { Link as CustomLink } from '@components/CustomLink';
// import { PrismicLink, PrismicImage, PrismicRichText } from "@prismicio/react";
import styled, { css } from 'styled-components';
import theme,{ media } from "@styles/theme";
import LogoIcon from '@assets/NewLightLogoIcon.svg';
import { Link as PrismicLink } from '@components/CustomLink';

const StyledWrapper = styled(Wrapper as any)`
  background: ${({theme}) => theme.colors.dark};
  border-top: 1px solid #b0d3dd33;

  a {
    text-decoration: none;
    color: #B0D3DD;
    line-height: 140%;
  }
`;

const StyledContainer = styled(Container as any)`
  color: #B0D3DD;
  padding-bottom: 48px;

  @media (min-width: 1192px) {
    max-width: 1192px;
    padding-right: 36px;
    padding-left: 36px;
  }
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-gap: 24px;
  padding: 60px 0;

  @media ${media.sm_up} {
    padding: 120px 0;
  }
`;

const SocialWrapper = styled.div`
  display: flex;
  grid-gap: 8px;
`;

const FootnoteParagraphWrapper = styled.div`
  margin-top: 17px;
  margin-bottom: 48px;
  line-height: 140%;

  p {
    margin: 0 0 10px 0;
  }
  
  a {
    text-decoration: underline;
  }
`;

const FooterLogoWrapper = styled.div`
  width: 194px;
  height: auto;
`;

const BottomLinksMenu = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  grid-gap: 8px;
  list-style-type: none;
  padding: 0;
  margin: 0;

  @media ${media.sm_up} {
    flex-direction: row;
    grid-column-gap: 32px;
  }
`;

const BottomLinksWrapper = styled.div`
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
`;

const FootnoteWrapper = styled.div`
  margin-top: 60px;

  @media ${media.md_up} {
    margin-top: 120px;
  }
`;

const MobileMenu = styled.ul`
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  list-style-type: none;
  margin: 0;
  padding: 0;

  @media ${media.sm_up} {
    display: none;
  }
`;

const DesktopSubMenu = styled.ul`
  display: flex;
  flex-direction: column;
  grid-row-gap: 8px;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const DesktopMenus = styled.ul`
  /* display: flex; */
  flex-direction: column;
  display: none;
  list-style-type: none;
  margin: 0;
  padding: 0;

  @media ${media.sm_up} {
    flex-direction: row;
    justify-content: space-between;
    display: flex;
  }

  @media ${media.md_up} {
    grid-gap: 32px;
  }

  li p.title {
    margin-bottom: 20px;
  }
   /* className="flex-col sm:flex-row sm:justify-between md:gap-x-[32px] hidden sm:flex" */
`;

const Angle = styled.div`
  position: relative;
  margin-left: auto;
`;

const YellowButtonWrapper = styled.div`
  button {
    text-decoration: none;
    text-align: center;
    padding: 15px 28px;
    display: inline-block;
    font-size: 18px;
    border-radius: 99999px;
    border: none;

    margin-right: 8px;
    display: inline-block;
    margin: 10px 0;
    background: #F5F5AB;
    color: #58583E;
    transition: all .3s;

    @media ${media.md_up} {
      &:hover {
        background-color: #fff;
      }
    }
  }
`;

const ResetCookieButton = styled.button`
  background-color: transparent;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  border: none;
  padding: 0;

  @media ${media.md_up} {
      transition: opacity .3s;
      &:hover {
        opacity: 0.7;
        text-decoration: underline;
      }
    }
`;

export const LinkWrapper = styled.span`
  a {
    font-size:15px;
    @media ${media.md_up} {
      transition: opacity .3s;
      &:hover {
        color: inherit;
        opacity: 0.7;
        text-decoration: underline;
      }
    }
  }
`;

const H3 = styled.h3`
  ${ChromaticFont};
  font-size: 64px;
  font-weight: bold;
  line-height: 110%;
  /* text-transform: uppercase; */
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  width: 83%;

  @media ${media.sm} {
    font-size: 48px;
  }
`;

export const Button = styled.button<{ $noIcon?: boolean }>`
  display: flex;
  width: 100%;
  border: none;
  outline: none;
  padding: 0;
  text-align: left;
  background: none;
  padding: 11px 0;
  position: relative;
  padding-right: 20px;
  color: ${theme.colors.darkGrey};

  ${({$noIcon}) => $noIcon ? css`
    pointer-events: none;

    ${Angle} {
      display: none;
    }
    /* &:after {
      content: "";
      height: 16px;
      width: 16px;
      position: absolute;
      right: 0;
      top: calc(50% - 8px);
    } */
  ` : css`
    /* opacity: .7; */
  `}

  ${P2} {
    margin: 0;
    font-weight: 700;
    font-size: 18px;
    /* color: ${theme.colors.darkGrey} */
  }
`;

export const CollapseBody = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  padding: 0 0 0 16px;
  margin: 0;
  height: 1px;
  pointer-events: none;
  overflow: hidden;
  opacity: 0;
  grid-row-gap: 4px;

  li {
    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &:last-child {
      margin-bottom: 30px;
    }
  }
`;


export const Collapse = styled.li<{ $expanded: boolean, lightIndicator?: boolean }>`
  ${({$expanded, lightIndicator}) => $expanded ? css`
    ${Button} {

      ${Angle} {
        transform: rotate(180deg);
      }
    }
  
    ${CollapseBody} {
      height: auto;
      pointer-events: initial;
      overflow: visible;
      opacity: 1;
      padding-top: 20px;
    }
  ` : css`
    ${Button} {
      &:after {
        ${lightIndicator ? css`

          background: brown;
        ` : css`

          background: red;
        `}
      }
    }
  `}
  

  /* border-top: 1px solid ${theme.colors.grey}; */

  /* &:last-child {
    border-bottom: 1px solid ${theme.colors.grey};
  } */

  /* &:first-child {
    border-top: none;
  } */
`;

const StyledLinkWrapper = styled(LinkWrapper)`
  padding: 11px 0;
  display: block;
`;

function setCookie(name: string, value: string, options = {}) {

  options = {
    path: '/',
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

function deleteCookie(name: string) {
  setCookie(name, "", {
    'max-age': -1,
    domain: `${process.env.GASTBY_COOKIE_DOMAIN}`.split('//').at(-1)
  })
}

const globalParams = {
  data: {
    footer_title: "Still have questions?",
      twitter_icon_link: {
        "link_type": "Web",
        "url": "https://twitter.com/CounterpartIns",
        "target": "_blank"
    },
      linkedin_icon_link: {
        "link_type": "Web",
        "url": "https://www.linkedin.com/company/yourcounterpart/",
        "target": "_blank"
    },
    api_terms_link: {
      "id": "ZTReTRIAAFM1yFQO",
      "type": "infopage",
      "tags": [],
      "lang": "en-us",
      "slug": "-",
      "first_publication_date": "2023-10-21T23:27:12+0000",
      "last_publication_date": "2023-10-29T16:30:02+0000",
      "uid": "api-terms",
      "url": "https://yourcounterpart.com/api-terms",
      "link_type": "Web",
      "isBroken": false
  },
    signature_link: {
      "id": "ZTReCRIAAEw1yFLf",
      "type": "infopage",
      "tags": [],
      "lang": "en-us",
      "slug": "-",
      "first_publication_date": "2023-10-21T23:26:04+0000",
      "last_publication_date": "2023-10-21T23:26:04+0000",
      "uid": "counterpart-electronic-signature-and-disclosures",
      "url": "https://yourcounterpart.com/counterpart-electronic-signature-and-disclosures",
      "link_type": "Web",
      "isBroken": false
  },
  trust_center_link: {
    link_type: 'Web',
    key: 'c4500f8f-b911-4fde-ba8a-768941e36415',
    url: 'https://trust.yourcounterpart.com'
    },
    terms_link: {
      "id": "ZTRdFhIAACg1yE6j",
      "type": "infopage",
      "tags": [],
      "lang": "en-us",
      "slug": "-",
      "first_publication_date": "2023-10-21T23:22:14+0000",
      "last_publication_date": "2023-10-21T23:23:16+0000",
      "uid": "terms",
      "url": "https://yourcounterpart.com/terms",
      "link_type": "Web",
      "isBroken": false
  },
    privacy_link: {
      "id": "ZS6KGhEAAL4sRYO3",
      "type": "infopage",
      "tags": [],
      "lang": "en-us",
      "slug": "-",
      "first_publication_date": "2023-10-17T13:20:29+0000",
      "last_publication_date": "2023-10-31T02:01:58+0000",
      "uid": "privacy",
      "url": "https://yourcounterpart.com/privacy",
      "link_type": "Web",
      "isBroken": false
  },
  licenses_link: {
    "id": "ZS6KGhEAAL4sRYO3",
    "type": "infopage",
    "tags": [],
    "lang": "en-us",
    "slug": "-",
    "first_publication_date": "2023-10-17T13:20:29+0000",
    "last_publication_date": "2023-10-31T02:01:58+0000",
    "uid": "licenses",
    "url": "https://yourcounterpart.com/licenses",
    "link_type": "Web",
    "isBroken": false
},
    footer_footnote: [{
      "type": "paragraph",
      "text": "*Rating as of February 26, 2024. AM Best ratings are under continuous review and subject to change. Please refer to Aspen’s website and Westfield's for the most current information. The rating represents the overall financial status of Aspen Speciality Insurance Company, and Westfield Specialty, and is not a recommendation of the specific policy provisions, rates or practices of the issuing insurance company.",
      "html": `<p><strong>© 2026 Counterpart, Inc. | Licensed in all 50 states and D.C. | CA License # 6000547</strong></p><p>Insurance products are offered in the U.S. by Counterpart Insurance Services, Inc., a licensed insurance producer and surplus lines broker. Insurance products may not be available in all states. For further details, <a target="_blank" href="https://yourcounterpart.com/licenses" rel="noreferrer">see here</a>.</p><p>*Rating as of February 26, 2024. AM Best ratings are under continuous review and subject to change. Please refer to Aspen’s website and Westfield's for the most current information. The rating represents the overall financial status of Aspen Speciality Insurance Company, and Westfield Specialty, and is not a recommendation of the specific policy provisions, rates or practices of the issuing insurance company.</p><p>The information contained herein is provided solely as a general overview of products and services offered by Westfield Specialty®, Aspen Specialty Insurance Company, and Counterpart and does not replace the terms and conditions of the actual policy language. This information is not to be considered a firm offer to sell insurance and does not constitute a binding contract. All submissions for insurance are subject to normal underwriting standards and guidelines applicable to a risk. Westfield Specialty, Aspen Specialty Insurance Company, and Counterpart reserve the right to change any of the terms and conditions or the availability of products and services. Products and services may not be available in all states.</p>`,
      "spans": [],
      "direction": "ltr"
    }],
    footer_logo: {
      "image": {
          "dimensions": {
              "width": 936,
              "height": 936
          },
          "alt": null,
          "copyright": null,
          "url": "https://images.prismic.io/counterpart-v2-next/653fb7de0b105250cf53bdaa_MattCulkin.png?auto=format,compress"
      },
      "quote": [
          {
              "type": "paragraph",
              "text": "Counterpart underwriters are extremely responsive, whether it's a quick ‘yes’ or a quick ‘no.’ We don't really have time to track down dozens of underwriters on every single deal. We appreciate knowing quickly whether or not you're going to be a fit.",
              "spans": [],
              "direction": "ltr"
          }
      ],
      "name": "Matt Culkin",
      "position": "PL Risk",
      "button_link": {
          "link_type": "Any"
      },
      "button_text": "See case study"
  },
  slices: [
    {
      "variation": "default",
      "version": "initial",
      "items": [
        {
          "child_name": "Private Directors & Officers",
          "child_link": {
            "id": "ZTgMhRIAAImb2TH-",
            "type": "product",
            "tags": [],
            "lang": "en-us",
            "slug": "directors--officers-liability-insurance",
            "first_publication_date": "2023-10-24T18:31:19+0000",
            "last_publication_date": "2024-06-12T05:15:44+0000",
            "uid": "do",
            "url": "https://yourcounterpart.com/products/do",
            "link_type": "Web",
            "key": "a2513914-c759-4cd1-ad39-f72e99dbd347",
            "isBroken": false
          }
        },
        {
          "child_name": "Not-For-Profit Directors & Officers",
          "child_link": {
            "id": "Zl_DcBMAACwAi8Mq",
            "type": "product",
            "tags": [],
            "lang": "en-us",
            "slug": "not-for-profit-directors--officers-liability-insurance",
            "first_publication_date": "2024-06-11T23:49:50+0000",
            "last_publication_date": "2024-06-13T16:19:52+0000",
            "uid": "not-for-profit-do",
            "url": "https://yourcounterpart.com/products/not-for-profit-do",
            "link_type": "Web",
            "key": "2736cb87-1575-4618-a1ea-ee5e6c076dd0",
            "isBroken": false
          }
        },
        {
          "child_name": "Employment Practices",
          "child_link": {
            "id": "ZTflQhIAAHeI2HyS",
            "type": "product",
            "tags": [],
            "lang": "en-us",
            "slug": "employment-practices-liability-insurance",
            "first_publication_date": "2023-10-24T18:31:34+0000",
            "last_publication_date": "2024-06-12T05:16:05+0000",
            "uid": "epli",
            "url": "https://yourcounterpart.com/products/epli",
            "link_type": "Web",
            "key": "b919bdf6-91e1-4a45-adae-09cf0a63066e",
            "isBroken": false
          }
        },
        {
          "child_name": "Fiduciary",
          "child_link": {
            "id": "ZTgMTxIAAImb2TEL",
            "type": "product",
            "tags": [],
            "lang": "en-us",
            "slug": "fiduciary-liability-insurance",
            "first_publication_date": "2023-10-24T18:31:27+0000",
            "last_publication_date": "2024-10-03T17:30:32+0000",
            "uid": "fid",
            "url": "https://yourcounterpart.com/products/fid",
            "link_type": "Web",
            "key": "b094d4de-2d99-46e7-86a5-71ba34c7f0f2",
            "isBroken": false
          }
        },
        {
          "child_name": "Commercial Crime",
          "child_link": {
            "id": "ZTgLpBIAACOb2S3h",
            "type": "product",
            "tags": [],
            "lang": "en-us",
            "slug": "commercial-crime-liability-insurance",
            "first_publication_date": "2023-10-25T22:23:30+0000",
            "last_publication_date": "2024-06-12T05:16:47+0000",
            "uid": "crime",
            "url": "https://yourcounterpart.com/products/crime",
            "link_type": "Web",
            "key": "051afce3-f6ca-4b01-9509-a49b90eb4e87",
            "isBroken": false
          }
        },
        {
          "child_name": "Professional & General Liability",
          "child_link": {
            "id": "ZLBd9xIAACEAa890",
            "type": "product",
            "tags": [],
            "lang": "en-us",
            "slug": "counterpart-miscellaneous-professional-liability",
            "first_publication_date": "2023-07-13T20:26:36+0000",
            "last_publication_date": "2024-10-03T17:23:01+0000",
            "uid": "miscellaneous-professional",
            "url": "https://yourcounterpart.com/products/miscellaneous-professional",
            "link_type": "Web",
            "key": "eda16a3e-65a3-434f-89b1-ccd5ea7134ec",
            "isBroken": false
          }
        },
        {
          "child_name": "Allied Medical & Healthcare Liability",
          "child_link": {
            "id": "aBQpJBkAAE0AEVeP",
            "type": "product",
            "tags": [],
            "lang": "en-us",
            "slug": "allied-medical--healthcare-liability",
            "first_publication_date": "2025-07-10T15:00:10+0000",
            "last_publication_date": "2025-07-10T15:00:10+0000",
            "uid": "allied-healthcare",
            "url": "https://yourcounterpart.com/products/allied-healthcare",
            "link_type": "Web",
            "key": "9c6f9194-49e8-466a-b127-809a1c9f5682",
            "isBroken": false
          }
        }
      ],
      "primary": {
        "name": "Products",
        "logo_link": {
          "link_type": "Any"
        }
      },
      "id": "navigation_item$21af819c-f871-498f-a63f-4d43085e162f",
      "slice_type": "navigation_item",
      "slice_label": null
    },
    {
      "variation": "default",
      "version": "initial",
      "items": [
        {
          "child_name": "Agentic Risk Mitigation™",
          "child_link": {
            "id": "Z851gRoAAEgAb-hx",
            "type": "service",
            "tags": [],
            "lang": "en-us",
            "slug": "agentic-risk-mitigation",
            "first_publication_date": "2025-03-13T00:03:08+0000",
            "last_publication_date": "2025-04-02T19:57:31+0000",
            "uid": "risk-mitigation",
            "url": "https://yourcounterpart.com/services/risk-mitigation",
            "link_type": "Web",
            "key": "60a7198f-bc8a-4727-a507-a153c88b067c",
            "isBroken": false
          }
        },
        {
          "child_name": "Agentic Claims Management™",
          "child_link": {
            "id": "ZxHv9RoAAEEAvihJ",
            "type": "service",
            "tags": [],
            "lang": "en-us",
            "slug": "agentic-claims-management",
            "first_publication_date": "2024-11-22T00:19:29+0000",
            "last_publication_date": "2025-03-28T19:40:18+0000",
            "uid": "claims-management",
            "url": "https://yourcounterpart.com/services/claims-management",
            "link_type": "Web",
            "key": "4af81a5c-eff1-45a3-8fde-76de3f22582f",
            "isBroken": false
          }
        }
      ],
      "primary": {
        "name": "For Businesses",
        "logo_link": {
          "link_type": "Any"
        }
      },
      "id": "navigation_item$c0ad025a-8e3a-4d27-880b-ab14291e8965",
      "slice_type": "navigation_item",
      "slice_label": null
    },
    {
      "variation": "default",
      "version": "initial",
      "items": [
        {
          "child_name": "Agentic Underwriting™",
          "child_link": {
            "id": "Z75MLxsAAEgACOJE",
            "type": "service",
            "tags": [],
            "lang": "en-us",
            "slug": "agentic-underwriting",
            "first_publication_date": "2025-03-13T00:00:20+0000",
            "last_publication_date": "2025-03-19T01:00:59+0000",
            "uid": "underwriting",
            "url": "https://yourcounterpart.com/services/underwriting",
            "link_type": "Web",
            "key": "9a1aaff4-f064-4f68-a955-804421ba74ce",
            "isBroken": false
          }
        },
        {
          "child_name": "Agentic Broker Services™",
          "child_link": {
            "id": "ZM0X7BEAACAAblsN",
            "type": "broker_service",
            "tags": [],
            "lang": "en-us",
            "slug": "broker-service",
            "first_publication_date": "2023-08-04T15:23:28+0000",
            "last_publication_date": "2025-03-13T00:02:49+0000",
            "uid": "brokers",
            "url": "https://yourcounterpart.com/brokers",
            "link_type": "Web",
            "key": "b2f90ea4-00fb-4eb8-b6ef-a85779e9f42a",
            "isBroken": false
          }
        },
        {
          "child_name": "Our Appetite",
          "child_link": {
            "id": "aF1W-xkAAEsAuMod",
            "type": "product",
            "tags": [],
            "lang": "en-us",
            "slug": "brand-light-green",
            "first_publication_date": "2025-06-27T19:26:45+0000",
            "last_publication_date": "2025-07-02T00:06:26+0000",
            "uid": "our-appetite",
            "url": "https://yourcounterpart.com/products/our-appetite",
            "link_type": "Web",
            "key": "7d87e2a6-e3a2-4ebf-8ace-aac23b42b52c",
            "isBroken": false
          }
        },
        {
          "child_name": "Digital Application",
          "child_link": {
            "id": "Zz_Xth4AAEgAftbl",
            "type": "service",
            "tags": [],
            "lang": "en-us",
            "slug": "digital-application",
            "first_publication_date": "2025-02-05T19:00:11+0000",
            "last_publication_date": "2025-02-05T19:00:11+0000",
            "uid": "digital-application",
            "url": "https://yourcounterpart.com/services/digital-application",
            "link_type": "Web",
            "key": "991b5b6a-bb50-4f32-bd1e-b65024577b08",
            "isBroken": false
          }
        },
        {
          "child_name": "API Partner",
          "child_link": {
            "id": "ZbvqlRIAADIG_vtE",
            "type": "service",
            "tags": [],
            "lang": "en-us",
            "slug": "api",
            "first_publication_date": "2024-02-01T19:07:11+0000",
            "last_publication_date": "2024-08-06T19:29:24+0000",
            "uid": "api",
            "url": "https://yourcounterpart.com/services/api",
            "link_type": "Web",
            "key": "10732b46-a1b3-46c2-9065-6f882f10232f",
            "isBroken": false
          }
        },
        {
          "child_name": "Knowledge Center",
          "child_link": {
            "link_type": "Web",
            "key": "87fc4a7b-4957-4242-91be-8374434bfff4",
            "url": "https://knowledge.yourcounterpart.com/en/",
            "target": ""
          }
        }
      ],
      "primary": {
        "name": "For Brokers",
        "logo_link": {
          "link_type": "Any"
        }
      },
      "id": "navigation_item$0069d400-0f8e-4698-aaa1-50cd468e4da0",
      "slice_type": "navigation_item",
      "slice_label": null
    },
    {
      "variation": "default",
      "version": "initial",
      "items": [
        {
          "child_name": "About Us",
          "child_link": {
            "id": "ZQhkMxAAACgAeeTO",
            "type": "about_us",
            "tags": [],
            "lang": "en-us",
            "slug": "about-us",
            "first_publication_date": "2023-09-18T14:52:37+0000",
            "last_publication_date": "2025-07-02T01:55:23+0000",
            "uid": "about",
            "url": "https://yourcounterpart.com/about",
            "link_type": "Web",
            "key": "514e4cd4-bd67-4225-b94d-756528868cb0",
            "isBroken": false
          }
        },
        {
          "child_name": "Careers",
          "child_link": {
            "link_type": "Web",
            "key": "82136931-44de-4d3b-aae6-b0de885c7907",
            "url": "https://yourcounterpart.com/about/#careers",
            "target": "_blank"
          }
        },
        {
          "child_name": "Press",
          "child_link": {
            "link_type": "Web",
            "key": "88adf09d-3381-41ff-902a-22bec43721f1",
            "url": "https://press.yourcounterpart.com"
          }
        },
        {
          "child_name": "Blog",
          "child_link": {
            "link_type": "Web",
            "key": "b5697fd6-8e59-4d83-b0c5-1d46bec4b4f3",
            "url": "https://blog.yourcounterpart.com"
          }
        }
      ],
      "primary": {
        "name": "Company",
        "logo_link": {
          "link_type": "Any"
        }
      },
      "id": "navigation_item$f6dc225f-1aea-499c-a844-23025da3cdb8",
      "slice_type": "navigation_item",
      "slice_label": null
    }
  ]
  }
}


export default function Footer ({ params }: {params: any}) {

  const [expanded, setExpanded] = useState("");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, [])

  // console.log(params)
  const handleClick = (e: React.SyntheticEvent<HTMLButtonElement>) => {

    if (e.currentTarget.name === expanded) {
      setExpanded("");
    } else {
      setExpanded(e.currentTarget.name);
    }
    // setShowMore('');
  };

  const handleShowIntercom = (e) => {
    if ((typeof window !== 'undefined') && (!!document)) {
      e.preventDefault();
      
      if (window?.Intercom) {
        window?.Intercom('show');
      }
    }
  }

  const resetCookies = () => {
    if (typeof window !== 'undefined') {
      document.cookie.split('; ').forEach(c => {
        const key = c.split('=')[0];
        deleteCookie(key);
      });
  
      window.location.reload();
    }
  }


  // console.log(params.data.slices)

  if (1) {  // TODO: That's workaround, fix this asap. Without it, there are issues with className on some pages, solution took from here, seems like client is trying to render before page is mounted  https://stackoverflow.com/questions/72829305/prop-classname-did-not-match-server-and-client
    return (
      <StyledWrapper $noColor>
        <footer>
          <StyledContainer>
              <TopWrapper>
                <H3>{globalParams.data.footer_title}</H3>
                <YellowButtonWrapper>
                  <button onClick={handleShowIntercom} type="noWrapper" target="_blank">
                    Talk to us now
                    <span className="hidden">(link opens in new tab)</span>
                  </button>
                </YellowButtonWrapper>
              </TopWrapper>
              
              <div>
                <DesktopMenus>
                  {globalParams.data.slices.map((i: any, idx: number) => (
                    <React.Fragment key={idx}>
                      <li>
                        {i.primary.logo_link.link_type === 'Any' ? (
                          <p className="title">{i.primary.name}</p>
                        ) : (
                          <LinkWrapper>
                            <PrismicLink link={i.primary.logo_link}>{i.primary.name}</PrismicLink>
                          </LinkWrapper>
                        )}
                        <DesktopSubMenu>
                          {i.items.map((i: any, idx: number) => (
                            <li key={idx}>
                              <LinkWrapper>
                                <PrismicLink link={i.child_link}>{i.child_name}</PrismicLink>
                              </LinkWrapper>
                            </li>
                          ))}
                        </DesktopSubMenu>
                      </li>
                    </React.Fragment>
                  ))}
                </DesktopMenus>
                
                <MobileMenu>
                  {globalParams.data.slices.map((i: any, idx: number) => (
                    <Collapse $expanded={expanded === i.primary.name} key={i.primary.name}>
                      {i.primary.logo_link.link_type === 'Any' ? (
                        <Button name={i.primary.name} onClick={handleClick} $noIcon={!i.items.length}>
                          <P2>{i.primary.name}</P2>
                          <Angle>
                            <svg role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                              <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 8.79289C5.68342 8.40237 6.31658 8.40237 6.70711 8.79289L12 14.0858L17.2929 8.79289C17.6834 8.40237 18.3166 8.40237 18.7071 8.79289C19.0976 9.18342 19.0976 9.81658 18.7071 10.2071L12 16.9142L5.29289 10.2071C4.90237 9.81658 4.90237 9.18342 5.29289 8.79289Z" fill="#B0D3DD"/>
                            </svg>
                          </Angle>
                        </Button>
                      ) : (
                        <StyledLinkWrapper>
                          <PrismicLink link={i.primary.logo_link}>{i.primary.name}</PrismicLink>
                        </StyledLinkWrapper>
                      )}
                      {i.items.length ? <CollapseBody>
                        {i.items.map((i: any, idx: number) => (
                          <li className="" key={idx}>
                            <LinkWrapper>
                              <PrismicLink link={i.child_link}>{i.child_name}</PrismicLink>
                            </LinkWrapper>
                          </li>
                        ))}
                      </CollapseBody> : null}
                    </Collapse>
                  ))}
                </MobileMenu>
              </div>
              
              
              <FootnoteWrapper className="">
                <FooterLogoWrapper>
                  <img src={LogoIcon} alt="Logo icon" />
                </FooterLogoWrapper>
                <FootnoteParagraphWrapper>
                  <div>
                    <div dangerouslySetInnerHTML={{__html: globalParams.data.footer_footnote[0].html}}></div>
                  </div>
                </FootnoteParagraphWrapper>
              </FootnoteWrapper>
      
              <BottomLinksWrapper>
                <BottomLinksMenu>
                  <li>
                    <LinkWrapper>
                      <CustomLink link={globalParams.data.licenses_link}>Licenses</CustomLink>
                    </LinkWrapper>
                  </li>
                  <li>
                    <LinkWrapper>
                      <CustomLink link={globalParams.data.privacy_link}>Privacy policy</CustomLink>
                    </LinkWrapper>
                  </li>
                  <li>
                    <LinkWrapper>
                      <CustomLink link={globalParams.data.terms_link}>Terms of service</CustomLink>
                    </LinkWrapper>
                  </li>
                  <li>
                    <LinkWrapper>
                      <CustomLink link={globalParams.data.signature_link}>eSignature</CustomLink>
                    </LinkWrapper>
                  </li>
                  <li>
                    <LinkWrapper>
                      <CustomLink link={globalParams.data.api_terms_link}>API Terms of service</CustomLink>
                    </LinkWrapper>
                  </li>

                   <li>
                    <LinkWrapper>
                      <CustomLink link={globalParams.data.trust_center_link}>Trust Center</CustomLink>
                    </LinkWrapper>
                  </li>
                  <li>
                    <ResetCookieButton onClick={resetCookies}>Cookie preferences</ResetCookieButton>
                  </li>
                </BottomLinksMenu>
                <SocialWrapper className="">
                  <div>
                    <LinkWrapper>
                      <CustomLink aria-label="Linkedin social media link" link={globalParams.data.linkedin_icon_link}>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="16" cy="16" r="16" fill="#F5F5AB"/>
                          <path d="M18.666 13.3335C19.7269 13.3335 20.7443 13.7549 21.4944 14.5051C22.2446 15.2552 22.666 16.2726 22.666 17.3335V22.0002H19.9993V17.3335C19.9993 16.9799 19.8589 16.6407 19.6088 16.3907C19.3588 16.1406 19.0196 16.0002 18.666 16.0002C18.3124 16.0002 17.9733 16.1406 17.7232 16.3907C17.4732 16.6407 17.3327 16.9799 17.3327 17.3335V22.0002H14.666V17.3335C14.666 16.2726 15.0874 15.2552 15.8376 14.5051C16.5877 13.7549 17.6051 13.3335 18.666 13.3335Z" fill="#58583E"/>
                          <path d="M12.0007 14H9.33398V22H12.0007V14Z" fill="#58583E"/>
                          <path d="M10.6673 10.6667C11.4037 10.6667 12.0007 10.0697 12.0007 9.33333C12.0007 8.59695 11.4037 8 10.6673 8C9.93094 8 9.33398 8.59695 9.33398 9.33333C9.33398 10.0697 9.93094 10.6667 10.6673 10.6667Z" fill="#58583E"/>
                        </svg>
                        <span className="hidden">(link opens in new tab)</span>
                      </CustomLink>
                    </LinkWrapper>
                  </div>
                  <div>
                    <LinkWrapper>
                      <CustomLink aria-label="Twitter social media link" link={globalParams.data.twitter_icon_link}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                          <circle cx="16" cy="16" r="16" fill="#F5F5AB"/>
                          <path d="M25 10.7755C24.3381 11.077 23.6263 11.2804 22.8789 11.3717C23.6416 10.9033 24.227 10.1613 24.5028 9.27662C23.7892 9.71074 22.9992 10.0259 22.1577 10.1959C21.4843 9.45994 20.5244 9 19.4623 9C17.4229 9 15.7694 10.6955 15.7694 12.7867C15.7694 13.0835 15.8021 13.3723 15.865 13.6495C12.7958 13.4918 10.0745 11.9844 8.25316 9.69317C7.93539 10.2522 7.75324 10.9026 7.75324 11.5969C7.75324 12.9106 8.40516 14.0695 9.39605 14.7488C8.79086 14.7289 8.22119 14.5587 7.72343 14.275C7.7231 14.2907 7.7231 14.3066 7.7231 14.3229C7.7231 16.1573 8.99606 17.6877 10.6856 18.0359C10.3757 18.1222 10.0494 18.1687 9.71255 18.1687C9.47435 18.1687 9.24314 18.1451 9.01762 18.1007C9.48776 19.605 10.8515 20.6999 12.4672 20.7304C11.2034 21.7462 9.61119 22.3515 7.8808 22.3515C7.58286 22.3515 7.28902 22.3334 7 22.2986C8.63459 23.3732 10.5755 24 12.6609 24C19.4537 24 23.1679 18.2298 23.1679 13.2258C23.1679 13.0619 23.1647 12.8981 23.1576 12.7359C23.8789 12.202 24.5053 11.5351 25 10.7755Z" fill="#58583E"/>
                        </svg>
                        <span className="hidden">(link opens in new tab)</span>
                      </CustomLink>
                    </LinkWrapper>
                  </div>
                </SocialWrapper>
              </BottomLinksWrapper>
      
          </StyledContainer>
        </footer>
      </StyledWrapper>
    )
  }
  
  return null;
}
